/* eslint-disable */
import React from 'react';
import Autocomplete from 'react-autocomplete';
import GoogleMapLoader from 'react-google-maps-loader';
import GooglePlacesSuggest from 'react-google-places-suggest';
import { connect } from 'react-redux';
import {
	TextField,
	InputAdornment,
	IconButton,
	ListItem
} from '@material-ui/core';
import { Clear, Search, Room } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import { getAutocompleteData } from '../../../redux/selectors';
import { updateSearchState } from '../../../redux/actions/search';

import AjaxHelper from '../../../common/AjaxHelper';
import Constants from '../../../common/Constants';
import TranslationHelper from '../../../common/TranslationHelper';
import UIHelper from '../../../common/UIHelper';

const styles = (theme) => ({
	icons: {
		fill: theme.palette.primary.main,
        margin: '0px 0px 3px 5px',
	}
});
class AutoCompleteInput extends React.Component {
	_isMounted = false;

	constructor(props) {
		super(props);

		this.state = {
            dateRange: {},
			googlePlacesSuggest: {},
			productNames: [],
			searchableFields: [],
			showDropdown: false,
			splitFieldValues: {
                location: ''
			},
			search: props.searchParams && props.searchParams.value ? props.searchParams.value : '',
			value: props.searchParams && props.searchParams.value
            ? props.searchParams.value
                : props.searchParams.suggestValue
                    ? props.searchParams.suggestValue
                    : ''
		};

		this.initialLoad = true;
		this._onKeyPress = this._onKeyPress.bind(this);
		this._onSelect = this._onSelect.bind(this);
		this.clearSearchText = this.clearSearchText.bind(this);
		this.getProductsForAutocomplete = this.getProductsForAutocomplete.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSelectSuggest = this.handleSelectSuggest.bind(this);
		this.onChangeValue = this.onChangeValue.bind(this);
		this.submitSearch = this.submitSearch.bind(this);
	}

	componentDidUpdate(prevProps) {
        if (prevProps && prevProps.searchParams && prevProps.searchParams.value !== this.props.searchParams.value && this.initialLoad) {
            this.initialLoad = false;
			/**
             * we keep the search value and the current filter values in the state - so when search changes we send both to the server
             * to make it a mutually exclusive search
			 */
            this.setState({
                splitFieldValues: {
                    ...this.state.splitFieldValues,
					location: this.props.searchParams && this.props.searchParams.value ? this.props.searchParams.value : '',
					category: this.props.searchParams && this.props.searchParams.filterAttributes && this.props.searchParams.filterAttributes.category
                    ? this.props.searchParams.filterAttributes.category
                    :						'',
				}
			});
		}
		/**
         * dont know how the below code works, suspect this is search functionality being affected by map etc. Anyhow try
         * and keep the functionality as is.
		 */
        if (typeof this.props.searchParams.resetLocation === 'boolean' && this.props.searchParams.resetLocation) {
			this.props.updateSearchStateDispatch({
				searchParams: {
					...this.props.searchParams,
					resetLocation: false,
				}
			});
			setTimeout(() => {
				this.setState({
					splitFieldValues: {
						...this.state.splitFieldValues,
						location: '',
					},
					search: '',
					value: '',
				});
			}, 100);
		}
		setTimeout(() => {
			this.initialLoad = false;
		}, 2000);
	}

	async componentDidMount() {
		this._isMounted = true;
		const searchableAttributes = this.props.productAttributes && this.props.productAttributes.standardAttributes
			? this.props.productAttributes.standardAttributes.filter((attribute) => attribute.isSearchable)
			:			[];

		const sortSearchableAttributes = async (attributes) => {
			try {
				let finalOrder = [];
				const fieldsFromServer = await AjaxHelper.invokeServerAPIPromise('/api/getSearchableFieldsOrder');

				if (fieldsFromServer && fieldsFromServer.length) {
					fieldsFromServer.forEach((field) => {
						const foundAttribute = attributes.find((attribute) => attribute.uniqueName === field);
						if (foundAttribute) {
							finalOrder.push(foundAttribute);
						}
					});

					if (attributes.length !== fieldsFromServer.length) {
						const remainingAttributes = attributes.filter((attribute) => !fieldsFromServer.includes(attribute.uniqueName));
						remainingAttributes.forEach((attribute) => {
							finalOrder.push(attribute);
						});
					}
				} else {
					finalOrder = attributes;
				}

				if (this._isMounted) this.setState({ searchableFields: finalOrder });
			} catch (error) {
				console.log('error sorting searchable attributes', error);
			}
		};
		/**
		 * custom fields can be marked as searchable this brings all those searchable product attributes.
		 *
		 * We use these searchable product attributes when search bar is set as overlay on a banner - all searchable
		 * attributes are displayed as separate fields. <- NOTE: we dont have to support this functionality anymore.
		 */
		if (!this.state.searchableFields.length) {
			sortSearchableAttributes(searchableAttributes);
		}
	}

	clearSearchText() {
		this.setState({
			value: '',
			splitFieldValues: {
				...this.state.splitFieldValues,
				location: '',
			}
		});
		this.props.updateProducts({ filterAttributes: this.props.searchParams && this.props.searchParams.filterAttributes, value: null }, true, false);
		this.setState({ productNames: [] });
	}

	onChangeValue(e) {
		const { value } = e.target;
		this.setState({ value });
		if (value) {
			this.getProductsForAutocomplete({ value });
		} else {
			this.setState({ productNames: [] });
		}
	}

	async getProductsForAutocomplete(params = {}) {
		const { marketplaceType } = this.props;
		try {
			const apiEndPoint = marketplaceType === Constants.PRODUCT_TYPE ? '/api/productNames' : '/api/sellerTypeNames';
			const productNames = await AjaxHelper.invokeServerAPIPromise(apiEndPoint, params);
			this.setState({ productNames });
		} catch (error) {
			UIHelper.showErrorMessage('Error getting products for search! Please try again');
		}
	}

	_onKeyPress(e) {
		if (e.key === 'Enter') {
			this.setState({ productNames: [] });
			this.props.onEnterPress(this.state.value, {}, false, null);
		}
	}

	_onSelect(productName, address, centerGeo) {
		this.props.onEnterPress(`${productName} ${address}`, {}, true, centerGeo);
		this.props.handleMobileDialogClose && this.props.handleMobileDialogClose();
	}

	handleInputChange(e) {
		this.setState({
			search: e.target.value,
			value: e.target.value,
			showDropdown: true,
		});
	}

	/**
	 * search results setting on 'Screen Setting' -> Search Page can be by location or default. Location uses formatted address
	 *
	 * @param suggest
	 */
	handleSelectSuggest(suggest) {
		const { onEnterPress } = this.props;
		this.setState({
			showDropdown: false,
			value: suggest.formatted_address,
			search: '',
		});

		let address = suggest.formatted_address;
		let addressArray = address.split(',');
		addressArray = addressArray.map((part) => part.trim());
		let zip = '';

		if (addressArray.length === 4) {
			const zipArray = addressArray[2].trim().split(' ');
			zip = zipArray[1];
		} else {
			address = addressArray[0] + addressArray[1];
		}
		/**
		 * with enterprise package - the map changes when search is performed.
		 *
		 * onEnterPress - seem to come from parent component - did not look into what this does.
		 */

		const mapSearch = {
			zoom: 11,
			center: {
				lat: suggest.geometry.location.lat(),
				lng: suggest.geometry.location.lng()
			},
            suggestValue: suggest.formatted_address,
		};
		onEnterPress(
			null,
			{},
			false,
			null,
			Constants.SEARCH_BY_LOCATION,
			null,
			null,
			null,
			mapSearch,
		);
	}

	submitSearch(event) {
		// event.preventDefault();
		if (this.state.splitFieldValues && Object.keys(this.state.splitFieldValues).length) {
			const searchParams = {};

			Object.keys(this.state.splitFieldValues).forEach((key) => {
				switch (key) {
				case 'location':
					searchParams.value = this.state.splitFieldValues[key];
					break;
				case 'category':
					if (this.state.splitFieldValues[key]) {
						searchParams.filterAttributes = {
							...searchParams.filterAttributes,
							[key]: this.state.splitFieldValues[key],
						};
					}
					break;
				default:
					console.log('unknown key value -- pair:', key, '--', this.state.splitFieldValues[key]);
				}
			});

			if (this.state.dateRange && this.state.dateRange.startDate) {
				searchParams.dateRange = this.state.dateRange;
			}

			let zip = '';
			const { addressArray, googleAddressComponents } = this.state.googlePlacesSuggest;

			if (addressArray && addressArray.length && addressArray.length === 4) {
				const zipArray = addressArray[2].trim().split(' ');
				zip = zipArray[1];
			}

			this.props.updateProducts({
				filterAttributes: searchParams.filterAttributes,
				dateRange: searchParams.dateRange,
				zoom: 11,
				center: this.state.googlePlacesSuggest.center,
				searchByType: Constants.SEARCH_BY_LOCATION,
			}, true);
		} else {
			this.clearSearchText();
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	render() {
		const {
			googleMapAPIKey,
			searchBy,
			classes,
			theme,
            width,
            handleClose
		} = this.props;

		let autocomplete;
		if (searchBy === Constants.SEARCH_BY_LOCATION && googleMapAPIKey) {
			autocomplete = (
				<GoogleMapLoader
					params={{
						key: googleMapAPIKey,
						libraries: 'places,geocode',
					}}
					render={(googleMaps) => googleMaps && (
						<div className="width-full">
							<GooglePlacesSuggest
								autocompletionRequest={{
									input: this.state.search
								}}
								googleMaps={googleMaps}
								onSelectSuggest={(suggestion) => {
									this.handleSelectSuggest(suggestion);
                                    handleClose();
								}}
							>
								<div className="has-feedback has-search searchBarInput" id="searchBarInput">
									<TextField
										name="searchLocation"
										size="small"
										placeholder="Search a location"
										onChange={this.handleInputChange}
										type="text"
										value={this.state.value}
										fullWidth
										InputProps={{
											style: { backgroundColor: 'white', height: width === 'xs' ? '45px' : 'auto' },
                                            startAdornment: <InputAdornment position="start"><Search className={classes.icons} /></InputAdornment>,
											endAdornment:
												this.state.value
													&& (
														<InputAdornment position="end">
															<IconButton
																onClick={this.clearSearchText}
																edge="end"
																size="small"
																style={{ outline: 0, marginRight: '0px' }}
															>
                                                            <Clear className={classes.icons}/>
															</IconButton>
														</InputAdornment>
													)
										}}
									/>
								</div>
							</GooglePlacesSuggest>
						</div>
					)}
				/>
			);
		} else {
			autocomplete = (
				<Autocomplete
					getItemValue={(item) => ({
						productName: item.Product_Name ? item.Product_Name : null,
						address: item.address ? item.address : null,
						defaultAddress: item.defaultAddress ? item.defaultAddress : null
					})}
					items={this.state.productNames}
					renderItem={(item, isHighlighted) => {
						const address = (item.address) ? item.address.split(',') : [];
						return (
							<ListItem
								key={this.state.productNames.indexOf(item)}
								style={{
									background: isHighlighted ? theme.palette.primary.main : 'white',
									textAlign: 'left',
									zIndex: '1000',
									cursor: 'pointer'
								}}
							>
								{item.Product_Name
									? (
										<div className="autoComplete-item-product">
											<b>{item.Product_Name}</b>
											<br />
											<Room style={{ fontSize: '25px', margin: '0px 5px 4px 0px', fill: theme.palette.error.main }} />
											<p style={{ display: 'inline' }}>
												{' '}
												{address[1] ? address[1].trim() : ''}
												,
												{' '}
												{address[2] ? address[2].trim() : ''}
											</p>
										</div>
									)
									:								(
										<div className="autoComplete-item-address">
											<Room style={{ fontSize: '25px', margin: '0px 5px 4px 0px', fill: theme.palette.error.main }} />
											<p style={{ display: 'inline' }}>
												{' '}
												{item.address ? item.address.replace(' ', ', ') : ''}
											</p>
										</div>
									)}
							</ListItem>
						);
					}}
					renderInput={(props) => (
						<TextField
							{...props}
							name="search"
							size="small"
							ref={null}
							inputRef={props.ref}
							placeholder={TranslationHelper.getValue('customer_account.searchbar.placeholder')}
							type="text"
							value={this.state.value}
							fullWidth
							InputProps={{
                                style: { backgroundColor: 'white', height: width === 'xs' ? '45px' : 'auto' },
								startAdornment: <InputAdornment position="start"><Search className={classes.icons} /></InputAdornment>,
								endAdornment:
							this.state.value
								&& (
									<InputAdornment position="end">
										<IconButton
											aria-label="toggle password visibility"
											onClick={this.clearSearchText}
											edge="end"
											size="small"
											style={{ outline: 0 }}
										>
											<Clear className={classes.icons} />
										</IconButton>
									</InputAdornment>
								)
							}}
							onKeyPress={this._onKeyPress}
						/>
					)}
					value={this.state.value ? this.state.value : ''}
					autoHighlight={false}
					onChange={this.onChangeValue}
					onSelect={(val) => {
						this.setState({
							productNames: [],
							value: val.productName ? val.productName : val.address ? val.address : '',
						}, () => {
							this._onSelect(
								val.productName ? val.productName : '',
								val.defaultAddress ? val.defaultAddress : '',
								!val.productName && val.address ? val.address : null,
							);
						});
					}}
					inputProps={{
						type: 'search',
						id: 'searchID',
					}}
					wrapperStyle={{
						display: 'inline-block',
						width: '100%',
						zIndex: 2
					}}
					menuStyle={{
						maxWidth: '200px',
						borderRadius: '3px',
						boxShadow: 'rgb(0 0 0 / 10%) 0px 2px 12px',
						fontSize: '90%',
						position: 'fixed',
						overflow: 'auto',
						maxHeight: '50%',
						zIndex: 1101
					}}
					open={this.state.productNames && !!this.state.productNames.length}
				/>
			);
		}
		return autocomplete;
	}
}

const mapStateToProps = (store) => ({
	...getAutocompleteData(store),
});

const mapDispatchToProps = (dispatch) => ({
	updateSearchStateDispatch: (search) => dispatch(updateSearchState(search)),
});

export default withStyles(styles, { withTheme: true })(connect(
	mapStateToProps,
	mapDispatchToProps,
)(AutoCompleteInput));
